/** main_owner + main_admin — без модератора/промоутера */
export const MAIN_OWNER_AND_ADMIN_ROLES: string[] = ['main_owner', 'main_admin'];

/**
 * Доступ к разделу notifications: владелец, админ и модератор уведомлений.
 * Отдельная константа от MAIN_OWNER_AND_ADMIN_ROLES (та переиспользуется для VIP).
 */
export const NOTIFICATIONS_ROLES: string[] = [
  ...MAIN_OWNER_AND_ADMIN_ROLES,
  'notification_moderator',
];

/** Глобальная VIP-статистика (/vip-stats + ссылка в шапке): только владелец и админ. */
export const VIP_ADMIN_ROLES = MAIN_OWNER_AND_ADMIN_ROLES;

/**
 * Раздел VIP в карточке пользователя (/user/:id/vip): дополнительно доступен
 * модераторам — как transactions-history, к которому у них уже есть доступ.
 */
export const VIP_USER_SECTION_ROLES: string[] = [
  ...MAIN_OWNER_AND_ADMIN_ROLES,
  'main_moderator',
];

export const VIP_ENABLED_PROJECT = 'CSGOFAST';

type UserWithRoles = {
  roles?: string[] | null;
} | null | undefined;

function userHasAnyRole(user: UserWithRoles, roles: string[]): boolean {
  return !!user?.roles?.some((role: string) => roles.includes(role));
}

export function hasVipAdminAccess(user: UserWithRoles): boolean {
  return userHasAnyRole(user, VIP_ADMIN_ROLES);
}

export function canAccessVipUi(projectName: string, user: UserWithRoles): boolean {
  return projectName === VIP_ENABLED_PROJECT && hasVipAdminAccess(user);
}

export function hasVipUserSectionAccess(user: UserWithRoles): boolean {
  return userHasAnyRole(user, VIP_USER_SECTION_ROLES);
}

export function canAccessVipUserSection(projectName: string, user: UserWithRoles): boolean {
  return projectName === VIP_ENABLED_PROJECT && hasVipUserSectionAccess(user);
}
